const existingMatrices = {}

export const matrixCreator = ({ column, row, type }) => {
  if (!existingMatrices[type]) existingMatrices[type] = new Array(row).fill(null).map(() => new Array(column).fill(0))
  return existingMatrices[type]
}
